{
  "name": "file-monitoring-app",
  "type": "module",
  "version": "1.9.2-72-quick-omsorg-and-removing-ignore-changes.0",
  "scripts": {
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --coverage",
    "lint": "ng lint",
    "install": "cp ./package.json ./src/assets",
    "style-lint": "stylelint \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cdk": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@angular/material-luxon-adapter": "^22.2.1",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22",
    "@types/luxon": "^3.7.6",
    "@types/node": "24",
    "@typescript-eslint/eslint-plugin": "^8.71.0",
    "@typescript-eslint/parser": "^8.71.0",
    "@vitest/coverage-v8": "^5.0.3",
    "@vitest/ui": "^5.0.3",
    "angular-eslint": "^22.0.0",
    "eslint": "^10.12.0",
    "jsdom": "^30.1.2",
    "luxon": "^3.7.2",
    "postcss": "8.5.29",
    "stylelint": "^17.16.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.0",
    "vitest": "5.0.3",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz"
  }
}
